import type { Plugin, Context } from '@segment/analytics-next';

import { getSecondsSinceAppMount, getSecondsSinceSessionStart } from '../../utils/appMount';
import { firebaseAuth } from '../firebase';
import { platformContextService } from '../platformContext/PlatformContextService';

import { getBrowserSessionId } from './getBrowserSessionId';
import { getTabId } from './getTabId';
import { getDevice, getScreenSize } from './helpers';

export class EventEnrichmentPlugin implements Plugin {
  name = 'Event Enrichment';
  type = 'enrichment' as const;

  isLoaded() {
    return true;
  }

  async load() {
    // No async initialization needed
  }

  track(ctx: Context): Context {
    const enrichmentProps = {
      referrer: document.referrer,
      device: getDevice(),
      platform: platformContextService.getConfig().platform,
      screen_size: getScreenSize(),
      user_id: firebaseAuth.currentUser?.uid,
      session_time_secs: getSecondsSinceSessionStart(),
      since_app_mount_secs: getSecondsSinceAppMount(),
      browser_session_id: getBrowserSessionId(),
      tab_session_id: getTabId(),
      event_timestamp: new Date().toISOString(),
    };

    for (const [key, value] of Object.entries(enrichmentProps)) {
      ctx.updateEvent(`properties.${key}`, value);
    }

    return ctx;
  }
}
